import React, { useState, useEffect } from "react";
import { Button, Typography } from "antd";
import { useIntl } from "react-intl";
import { CloseOutlined } from "@ant-design/icons";
import ModalContentWrapper from "./ModalContentWrapper.style";
import Header from "./Header";
import Uploader from "./Uploader";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { loadPage } from "../../orders/OrdersSlice";
import { getFullName } from "../../../components/util/helpers";

const { Title } = Typography;
const UploadContent = (props) => {
  const { onMouseOver, onMouseOut, hide, handleUpload } = props;
  const [currentDate, setCurrentDate] = useState(moment());
  const [orders, setOrders] = useState([]);
  const [clients, setClients] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [orderEvents, setOrderEvents] = useState([]);
  const [employeeEvents, setEmployeeEvents] = useState([]);
  const [selectedClientName, setSelectedClientName] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState(null);
  const addAssetLoading = useSelector(
    (state) => state.pendingActions["workDiaries/addAsset"]
  );
  const createLoading = useSelector(
    (state) => state.pendingActions["workDiaries/create"]
  );
  const currentAppLocale = useSelector((state) => state.user.currentAppLocale);
  const dispatch = useDispatch();
  const { page: ordersPage } = useSelector((state) => state.orders);
  const { items } = ordersPage;

  const loading = addAssetLoading || createLoading;
  useEffect(() => {
    dispatch(loadPage());
  }, [dispatch]);

  useEffect(() => {
    const planOrders = items.filter(
      (p) =>
        currentDate.endOf("month").isAfter(p.effective_from) &&
        (p.effective_to === null ||
          currentDate.startOf("month").isBefore(p.effective_to))
    ); //check if order is included in relevenat month
    let clientsList = [];
    planOrders.forEach((item, i) => {
      const temp = {
        orderId: item.id,
        id: item.client_id,
        name: item.client.name,
      };
      clientsList.push(temp);
    });
    setOrders(planOrders);
    setClients(clientsList);
  }, [items, currentDate]);

  useEffect(() => {
    const selectedOrder = orders.filter(
      (item) => item.id === selectedClientId
    )[0];
    setOrderEvents(selectedOrder ? selectedOrder.recurrent_work_events : []);
    setSelectedClientName(selectedOrder ? selectedOrder.client.name : "");
  }, [selectedClientId, orders]);

  useEffect(() => {
    let arr = [];
    orderEvents.forEach((item, i) => {
      if (item.employee) {
        const temp = {
          id: item.employee.id,
          name: getFullName(item.employee.surename, item.employee.first_name),
        };
        arr.push(temp);
      }
    });
    var uniqueEmployees = Array.from(new Set(arr.map(JSON.stringify))).map(
      JSON.parse
    );
    setEmployees(uniqueEmployees);
  }, [orderEvents]);

  useEffect(() => {
    let arr = [];
    orderEvents.forEach((item, i) => {
      if (item.employee_id === selectedEmployeeId) {
        arr.push(item);
      }
    });
    setEmployeeEvents(arr);
  }, [selectedEmployeeId, orderEvents]);

  const onClientChanged = (val) => {
    setSelectedClientId(val);
  };

  const onEmployeeChanged = (val) => {
    setSelectedEmployeeId(val);
  };

  const onNextDate = () => {
    setCurrentDate(moment(currentDate).add(1, "months").startOf("month"));
    setSelectedClientId(null);
    setSelectedEmployeeId(null);
  };
  const onPreviousDate = () => {
    setCurrentDate(moment(currentDate).subtract(1, "months").startOf("month"));
    setSelectedClientId(null);
    setSelectedEmployeeId(null);
  };

  const intl = useIntl();
  const onContinue = () => {
    const selectedOrderId = orders.filter(
      (item) => item.id === selectedClientId
    )[0].id;
    handleUpload(
      currentDate,
      selectedFile,
      selectedFileName,
      selectedOrderId,
      selectedEmployeeId
    );
  };

  const onFileSelected = (f) => {
    setSelectedFile(f);
  };

  const onFileNameChanged = (val) => {
    setSelectedFileName(val);
  };

  const disabled =
    !selectedFile ||
    !selectedFileName ||
    !selectedClientId ||
    !selectedEmployeeId;

  return (
    <ModalContentWrapper direction={currentAppLocale.direction}>
      <div className="top" onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
        <Button
          className="closeBtn"
          type="text"
          shape="circle"
          icon={<CloseOutlined />}
          onClick={hide}
        />
      </div>
      <div className="inner">
        <Title level={2}>
          {intl.formatMessage({
            id: "app.work_diary.uploadNewDiary",
          })}
        </Title>
        <div style={{ height: "20px" }} />
        <Header
          currentDate={currentDate}
          onNextDate={onNextDate}
          onPreviousDate={onPreviousDate}
          clients={clients}
          onClientChanged={onClientChanged}
          orderEvents={orderEvents}
          employees={employees}
          onEmployeeChanged={onEmployeeChanged}
          selectedClientId={selectedClientId}
          selectedEmployeeId={selectedEmployeeId}
          employeeEvents={employeeEvents}
          selectedClientName={selectedClientName}
        />
        <Uploader
          onFileSelected={onFileSelected}
          onFileNameChanged={onFileNameChanged}
        />
      </div>
      <div className="actions">
        <Button
          type="primary"
          onClick={onContinue}
          disabled={disabled}
          loading={loading}
        >
          {intl.formatMessage({
            id: "app.actions.upload",
          })}
        </Button>
      </div>
    </ModalContentWrapper>
  );
};

export default UploadContent;
